import Animation from './animation'

/*
 * This animation is used when a reference brand is split to "per-serie", which
 * means there are multiple points with the same rangeId.
 */
class AddSplitByAnimation extends Animation {

  match (serie) {
    if (!this.chart.previous) {
      return false
    }

    let prev = this.previous.series.data().find(s => s.id == serie.id)
    if (!prev) {
      // Didn't have this serie previously
      return false
    }

    if (!this.series.size()) {
      // No series to split
      return false
    }

    // Determine if we were previously split per field.
    let split0 = this.series.selection()
                            .filter(s => s.id == serie.id)
                            .selectAll('.reference-group').attr('data-split-by-serie') == 'true'
      , split1 = serie.points.some(p => typeof p.seriesRefId !== 'undefined') // Now are we split based on data

    return !split0 && split1 // We're split by "per-field" and previously we weren't.
  }

  _previousValues (selection) {
    let result = {fill: {}, line: {}}

    ;['line', 'fill'].forEach(type => {
      selection.selectAll(`path.${type}`).each((d, i) => {
        let thresholds = result[type][d.rangeId]
        if (!thresholds) {
          thresholds = {}
        }
        thresholds[d.color] = d.bounds || d.raw
        result[type][d.rangeId] = thresholds
      })
    })

    return result
  }

  animate (serie, enter, selection, merged, exit) {
    let _selection = merged.selection() // All elements
      , prevValues = this._previousValues(exit.selection())

    exit.selection().remove()

    this._fills(_selection, merged, point => {
      let prev = prevValues.fill[point.rangeId][point.color]
      return [
        this.previous.yScale(prev[0]),
        this.previous.yScale(prev[1])
      ]
      return
    })

    this._lines(_selection, merged, point => {
      let prev = prevValues.line[point.rangeId][point.color]
      return this.previous.yScale(prev)
    })

    // We don't want the elements to fade in. Immediately show them.
    _selection.selectAll('path.line').style('opacity', d => d.opacity)
    _selection.selectAll('path.fill').style('opacity', d => d.opacity)
  }

}

export default AddSplitByAnimation
